import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import {
  Grid,
  Paper,
  Typography,
} from '@mui/material'

import { isEmptyOrUndefined } from "@zippeditoolsjs/blocks";

import Selector from '../../tools/Selector';

export default function TopComponents(props) {
  const {
    theme,
    selectedClient,
    getChains,
    chains,
    isLoadingChains,
    selectedChain,
    setSelectedChain,
    selectedSupplier,
    setSelectedSupplier,
    storesLength,
    loadingTrackingListData,
    loadingTrackingListDataItems,
    getUserSuppliers,
    suppliers,
    isLoadingSuppliers,
  } = props;
  const { t } = useTranslation();
  const [filteredChain, setFilteredChain] = useState([]);

  // Lifecycle methods

  useEffect(() => {
    getChains();
  }, [])

  useEffect(() => {
    // Filter chains by selected client
    if (selectedClient?.client_id !== -1) {
      const filterChain = chains.filter(chain => chain?.name === selectedClient?.name);
      setFilteredChain(filterChain[0]);
    }
  }, [selectedClient, chains])

  // Get suppliers info when a chain is selected and reset the selected supplier
  useEffect(() => {
    if (!isEmptyOrUndefined(selectedChain, 'object')) {
      getUserSuppliers(selectedClient.client_id, [selectedChain?.name]);
    }
    setSelectedSupplier(null);
  }, [selectedChain])

  return (
    <Grid container columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}>
      <Paper component={Grid} container item columns={{ xs: 4, sm: 8, md: 12 }} alignItems='center' p={2} sx={{ backgroundColor: theme.palette.type === 'dark' ? '#2e2728' : '' }}>
        <Grid container item spacing={1} xs={12} sm={12} md={7}>
          {/* Chain selector */}
          <Grid item xs={12} sm={12} md={6}>
            <Selector
              labelInput="cws_app.general.sel_chain"
              options={selectedClient?.client_id !== -1 ? [filteredChain] : chains} // If a client is selected, only show the client as an option
              optionLabel={'name'}
              isLoading={isLoadingChains}
              selectedElement={selectedChain}
              setSelectedElement={setSelectedChain}
              disabled={loadingTrackingListData || loadingTrackingListDataItems}
            />
          </Grid>
          {/* Supplier selector */}
          <Grid item xs={12} sm={12} md={6}>
            <Selector
              labelInput="cws_app.management.select_supplier"
              options={suppliers}
              optionLabel={'name'}
              isLoading={isLoadingSuppliers}
              selectedElement={selectedSupplier}
              setSelectedElement={setSelectedSupplier}
              disabled={isEmptyOrUndefined(selectedChain, 'object') || loadingTrackingListData || loadingTrackingListDataItems}
              id={['id']}
            />
          </Grid>
        </Grid>
      </Paper>
      {/* Information cards */}
      {/* // TODO: add metrics */}
      {false && !isEmptyOrUndefined(selectedSupplier, 'object') && storesLength && chains?.length > 0 &&
        <Grid item xs={4} sm={8} md={12} lg={5}>
          <Grid container height='100%' justifyContent='space-between'>
            <Paper component={Grid} container item xs={12} sm={2.8} direction='column' mb={{ xs: 1, sm: 0 }} p={1} justifyContent='center' alignItems='center'>
              <Typography variant='h5'>5/{chains.length}</Typography>
              <Typography>{t('cws_app.general.chains', 'Chains')}</Typography>
            </Paper>
            <Paper component={Grid} container item xs={12} sm={2.8} direction='column' mb={{ xs: 1, sm: 0 }} p={1} justifyContent='center' alignItems='center'>
              <Typography variant='h5'>5/{storesLength}</Typography>
              <Typography>{t('cws_app.general.stores', 'Stores')}</Typography>
            </Paper>
            <Paper component={Grid} container item xs={12} sm={2.8} direction='column' mb={{ xs: 1, sm: 0 }} p={1} justifyContent='center' alignItems='center'>
              <Typography variant='h5'>5/425</Typography>
              <Typography>{t('cws_app.general.products', 'Products')}</Typography>
            </Paper>
            <Paper component={Grid} container item xs={12} sm={2.8} direction='column' p={1} justifyContent='center' alignItems='center'>
              <Typography variant='h5'>5/425</Typography>
              <Typography>{t('cws_app.tracking.Activated', 'Activated')}</Typography>
            </Paper>
          </Grid>
        </Grid>
      }
    </Grid>
  )
}
